export interface SaResourcesState {
  resRto: any;
}

export const initialState: SaResourcesState = {
  resRto: [],
};
